import * as Request from '../../../request'

export const TOGGLE_PREVIEW_NEWSBRIEF = 'TOGGLE_PREVIEW_NEWSBRIEF'
export const FETCH_PREVIEW = 'FETCH_PREVIEW'
export const FETCH_PREVIEW_REQUEST = `${FETCH_PREVIEW}_${Request.REQUEST}`
export const FETCH_PREVIEW_SUCCESS = `${FETCH_PREVIEW}_${Request.SUCCESS}`
export const FETCH_PREVIEW_ERROR = `${FETCH_PREVIEW}_${Request.ERROR}`



// WEBPACK FOOTER //
// ./src/pages/newsbrief/preview-newsbrief/constants.ts